import { render } from "./show.vue?vue&type=template&id=0e2a437d&scoped=true"
import script from "./show.vue?vue&type=script&lang=js"
export * from "./show.vue?vue&type=script&lang=js"

import "@/css/view.css?vue&type=style&index=0&id=0e2a437d&scoped=true&lang=css"
import "@/css/information.css?vue&type=style&index=1&id=0e2a437d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mr.Wu\\Desktop\\Files\\XiHe\\code\\xihe_levelexam_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2a437d"]])

export default __exports__